var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconWeatherShiny(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 42,
    viewBox: "0 0 41 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_754_1545)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.46 41.1505C31.7597 41.1505 40.92 31.9902 40.92 20.6905C40.92 9.39072 31.7597 0.230469 20.46 0.230469C9.16025 0.230469 0 9.39072 0 20.6905C0 31.9902 9.16025 41.1505 20.46 41.1505Z",
    fill: "url(#paint0_linear_754_1545)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_754_1545",
    x1: 5.99,
    y1: 35.1505,
    x2: 34.92,
    y2: 6.22047,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDB727"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFCD22"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_754_1545"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40.91,
    height: 40.91,
    fill: "white",
    transform: "translate(0 0.230469)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconWeatherShiny);
export default __webpack_public_path__ + "static/media/icon_weather_shiny.f992acd395c89427b52246cd17abc760.svg";
export { ForwardRef as ReactComponent };